import * as bootstrap from 'bootstrap';
import 'bootstrap/dist/css/bootstrap.min.css';
import AOS from 'aos';
import 'aos/dist/aos.css';
import '../styles/base.css';

import { initAutoDismissAlerts } from './modules/alerts';
import { initDashboardTooltips } from './modules/dashboardTooltips';
import { initFilterToggle } from './modules/filterToggle';
import { initInfiniteScroll } from './modules/infiniteScroll';
import { initPasswordToggle } from './modules/passwordToggle';
import { initStarRating } from './modules/ratingStars';
import { initImageUpload, initProfilePhotoUpload } from './modules/profilePhotoUpload';
import { initProfilePhotoPoll } from './modules/profilePhotoPoll';
import { initScheduleFormCascading } from './modules/scheduleFormCascading';
import { initScrollToTop } from './scrollToTop';

// Expose Bootstrap on window for modules or inline scripts that expect a global.
// This also keeps existing code using window.bootstrap working.
window.bootstrap = bootstrap;

document.addEventListener('DOMContentLoaded', () => {
  AOS.init({ duration: 800, once: true });

  // Scroll-to-top button and positioning
  initScrollToTop();

  // Only initialize infinite scroll on pages that need it
  if (document.querySelector('#activity-container')) {
    initInfiniteScroll();
  }

  // Initialize auto-dismiss for alerts without blocking other initializers.
  try {
    initAutoDismissAlerts();
  } catch (err) {
    console.warn('[alerts] initAutoDismissAlerts failed:', err);
  }

  // Initialize StarRating
  initStarRating();

  // Initialize filter toggle
  initFilterToggle();

  // Initialize dashboard and activities page tooltips
  if (document.querySelector('.supplier-dashboard') || document.querySelector('.supplier-content')) {
    initDashboardTooltips();
  }

  // Schedule form: filter activity/instructor by selected organization
  if (document.getElementById('id_organization') && document.getElementById('activities-by-org')) {
    initScheduleFormCascading();
  }

  // Account forms: password visibility toggle
  if (
    document.querySelector('.account-login-page') ||
    document.querySelector('.account-signup-page') ||
    document.querySelector('.account-profile-form-page') ||
    document.querySelector('.account-settings-page') ||
    document.querySelector('.account-password-change-page') ||
    document.querySelector('.account-password-reset-confirm-page')
  ) {
    initPasswordToggle();
  }

  // Profile update: presigned S3 photo upload
  if (document.querySelector('.account-profile-form-page')) {
    initProfilePhotoUpload();
  }

  // Account settings: poll for processed profile photo and update avatar
  if (document.querySelector('.account-settings-page')) {
    initProfilePhotoPoll();
  }

  // Organization create/update: direct-to-S3 image upload (pilot reusable flow)
  if (document.querySelector('.organization-form-page')) {
    initImageUpload({
      fileInputId: 'id_image',
      keyInputId: 'id_image_key',
      errorElementId: 'organization-image-upload-error',
      statusElementId: 'organization-image-upload-status',
      previewImageId: 'organization-image-preview',
      presignedUrlEndpoint: '/account/upload/presigned-upload-url/organization/',
      deleteTempEndpoint: '/account/upload/delete-temp-photo/organization/',
    });
  }

  // Activity create/update: direct-to-S3 image upload
  if (document.querySelector('.activity-form-page')) {
    initImageUpload({
      fileInputId: 'id_image',
      keyInputId: 'id_image_key',
      errorElementId: 'activity-image-upload-error',
      statusElementId: 'activity-image-upload-status',
      previewImageId: 'activity-image-preview',
      presignedUrlEndpoint: '/account/upload/presigned-upload-url/activity/',
      deleteTempEndpoint: '/account/upload/delete-temp-photo/activity/',
    });
  }

  // Instructor create/update: direct-to-S3 photo upload
  if (document.querySelector('.instructor-form-page')) {
    initImageUpload({
      fileInputId: 'id_photo',
      keyInputId: 'id_photo_key',
      errorElementId: 'instructor-photo-upload-error',
      statusElementId: 'instructor-photo-upload-status',
      previewImageId: 'instructor-photo-preview',
      presignedUrlEndpoint: '/account/upload/presigned-upload-url/instructor/',
      deleteTempEndpoint: '/account/upload/delete-temp-photo/instructor/',
    });
  }
});
